import ClientSDK from '../App/ClientSDK'

import { IAPIAccountUpgrade } from './interface/IAPIAccountUpgrade'

export const subscribe = async (data: IAPIAccountUpgrade) => {
  const url = 'account/subscribe'
  return await ClientSDK.instance().post(url, data)
}

export const validateVat = async (vat: string) => {
  const url = 'account/vat-validation/' + vat
  const response = await (ClientSDK.instance() as ClientSDK).get(url)

  return response.data
}
